var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as React from 'react';
import FolderItem from './folder-item';
import { StyledMediaFolderPicker } from './style';
var MediaFolderPicker = /** @class */ (function (_super) {
    __extends(MediaFolderPicker, _super);
    function MediaFolderPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.handleExpand = function (expandedId, expanded) {
            if (expanded) {
                _this.setState(function (prevState) { return ({
                    expandedIds: __spreadArrays(prevState.expandedIds, [expandedId]),
                }); });
            }
            else {
                var removeExpandIds = _this.state.expandedIds.filter(function (id) { return id !== expandedId; });
                _this.setState({
                    expandedIds: removeExpandIds,
                });
            }
            if (_this.props.onExpand) {
                _this.props.onExpand(expandedId, expanded);
            }
        };
        _this.state = {
            expandedIds: _this.props.defaultExpandIds ? _this.props.defaultExpandIds : [],
        };
        return _this;
    }
    MediaFolderPicker.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.defaultExpandParent && this.props.data.id) {
            this.setState(function (prevState) { return ({
                expandedIds: __spreadArrays(prevState.expandedIds, [_this.props.data.id]),
            }); });
        }
    };
    MediaFolderPicker.prototype.render = function () {
        var _this = this;
        var data = this.props.data;
        if (!Array.isArray(data)) {
            data = [data]; // root node
        }
        return (React.createElement(StyledMediaFolderPicker, null,
            React.createElement("ul", { className: "tree-list" }, data.map(function (item) { return (React.createElement(FolderItem, { key: item.id, item: item, selectedId: _this.props.selectedId, disabled: false, onSelect: _this.props.onSelect, expandedIds: _this.state.expandedIds, onExpand: _this.handleExpand })); }))));
    };
    MediaFolderPicker.defaultProps = {
        defaultExpandParent: true,
    };
    return MediaFolderPicker;
}(React.Component));
export default MediaFolderPicker;
//# sourceMappingURL=index.js.map